import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import userService from "../../../app/services/user.service";
import Loader from "../../../UI/loader/loader";
//import { userList } from "../userList";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from "./Table.module.css";
import Toast from "../../../UI/Toast/Toast";
import { toast } from "react-toastify";

const DataTable = () => {
  const [showEntries, setShowEntries] = useState(25);
  const [userList, setUserList] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
   //loader
   const [loading, setLoading] = useState(false);
   
  useEffect(() => {
    setLoading(true)
    userService.getUserList()
    .then((data) => {

      const datas = data.data.data
      let uniqueObjectsArray = []
      console.log(datas,' \n uniqueObjectsArray1' ,uniqueObjectsArray)
      uniqueObjectsArray = datas.reduce((accumulator, current) => {
        if (
          !accumulator.find(
            (item) =>
              item.user_id === current.user_id
          )
        ) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);
      console.log(datas,' \n uniqueObjectsArray2' ,uniqueObjectsArray)

      const removeUserIdArray = [1, 2, 5, 313]
      for(let i = 0; i < removeUserIdArray.length; i++) {
        uniqueObjectsArray = uniqueObjectsArray.filter(x => x.user_id !== removeUserIdArray[i] )
      }
      uniqueObjectsArray = uniqueObjectsArray.map((item, i) =>{
        return {index:i+1 ,...item}
      })
     setUserList(uniqueObjectsArray)
     console.log(datas,' \n uniqueObjectsArray3' ,uniqueObjectsArray)
    }
    )
    .then(() => setLoading(false))
    .catch((error) => {
      setLoading(false);
      console.log(error)
      toast.error("something went wrong")
  })
  }, []);

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "id", sortable: false },
    { name: "User Name", field: "username", sortable: true },
    { name: "Name", field: "name", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Mobile No.", field: "mobile", sortable: false },
    { name: "Team Lead", field: "tl", sortable: false },
    { name: "Profile", field: "profile", sortable: false },
    { name: "Center", field: "center", sortable: false },
  ];


  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = userList;
    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.NAME.toLowerCase().includes(search.toLowerCase()) ||
          //comment.email.toLowerCase().includes(search.toLowerCase()) ||
          //comment.mobile.includes(search) ||
          comment["TblProfile.profile_name"].toLowerCase().includes(search.toLowerCase()) ||
          //comment.profile_name.toLowerCase().includes(search.toLowerCase()) ||
          comment["teamlead.team_lead_name"].toLowerCase().includes(search.toLowerCase()) ||
          comment.user_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [currentPage, search, sorting, ITEMS_PER_PAGE, userList]);

  return (
    <>
      {loading && <Loader/>}
      <Toast />
      <div className="d-flex justify-content-between">
        <div>
          Show{" "}
          <select
            onChange={(e) => {
              setShowEntries(e.target.value);
            }}
          >
            {/* <option value='10'>10</option>
                    <option value='20'>20</option> */}
            {userList.length === 0 && <option selected value="0">0</option>}
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          enteries
        </div>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered mt-3 mb-0">
          <TableHeader
            className={classes.header}
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.map((data, i) => (
              <tr key={data.user_id+data["teamlead.team_lead_name"]+Math.floor(Math.random()*10)+data["TblProfile.profile_name"]+Math.floor(Math.random()*10)+data["TblCenter.center"]+ Math.floor(Math.random()*10)}>
                <th scope="row">{data.index}</th>
                <td className={classes.link}>
                  <Link to='/userList/edit' state={{user_id:data.user_id, name:data.user_name}}>
                    {data.user_name}
                  </Link>
                </td>
                <td>{data.NAME}</td>
                <td>{data.email}</td>
                <td>{data.mobile}</td>
                <td>{data["teamlead.team_lead_name"]}</td>
                <td>{data["TblProfile.profile_name"]}</td>
                <td>{data["TblCenter.center"]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="small ">
        Showing{" "}
        <b>{+showEntries < userList.length ? +showEntries : userList.length}</b>{" "}
        out of {userList.length} enteries
      </p>
      <div className="mt-4">
        <Pagination
          total={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default React.memo(DataTable);
